import { Link } from 'react-router-dom';
import './Folder.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Розділ документів. Уся картка є посиланням, показує кількість документів.
 * Раніше клікабельною була тривимірна тека (div з onClick), а на мобільному
 * рендерився інший варіант розмітки за window.screen.availWidth.
 */
export default function Folder({ type, typeId, count }) {
  const language = useLanguage();

  return (
    <div className='folder-wrapper'>
      <Link className='folder-link' to={`/documents/${typeId}`}>
        <span className='folder-mark' aria-hidden='true' />
        <span className='folder-body'>
          <span className='type-name'>{type.name}</span>
          <span className='folder-count tnum'>
            {count} {language === 'en' ? 'documents' : 'документів'}
          </span>
        </span>
        <svg className='btn-arrow' width='20' height='20' viewBox='0 0 24 24' aria-hidden='true'>
          <path
            d='M5 12h14M13 6l6 6-6 6'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.6'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </Link>
    </div>
  );
}
